import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import estadoMock from '../../../common/mock/estadoMock';
import monedaService from "../../../service/administracion/monedaService";
import cajaService from '../../../service/administracion/cajaService';
import establecimientoService from '../../../service/administracion/establecimientoService';

import clienteService from '../../../service/administracion/clienteService';
import { FACTURA } from '../../../common/types/tipoComprobanteType';
import ImprimirModal from './ImprimirModal';

import cuentasCobrarService from '../../../service/tesoreria/cuentasCobrar';
import auth from '../../../common/utility/auth';
import comprobanteService from '../../../service/ventas/comprobanteService';
import metodoPagoService from '../../../service/administracion/metodoPagoService.js';

import cuentaService from '../../../service/administracion/cuentaService';
import bancoService from '../../../service/administracion/bancoService';
import formaPagoService from '../../../service/administracion/formaPagoService.js';
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';
import empresaService from '../../../service/administracion/empresaService';

import Header from './Header';

import ViewPago from './ViewPago';
import ViewPagoCredito from './ViewPagoCredito.js';
import SearchCreditoModal from './SearchCreditoModal';
//Service de Cobranzas

import cobranzaService from '../../../service/tesoreria/cobranzaService';
import Filters from './Filters';
import ResultList from './ResultList';
import ResultListDetalle from './ResultListDetalle';

import ResultListPlanillaResumen from './ResultListPlanillaResumen';
import ResultListPlanillaDetallado from './ResultListPlanillaDetallado';
import { TESORERIA } from '../../../common/types/moduloType';
import { VER_CAJA_COB } from '../../../common/types/configuracionType';


import printFormatMock from '../../../common/mock/printFormatMock';


export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            loadingImprimir: false,
            loadingPrint: false,
            loadingPago: false,
            loadingVer: false,
            viewVisible: false,
            viewCredito: false,
            viewPagoVisible: false,
            viewPagoDetalle: false,
            viewPagoCreditoVisible: false,
            viewHistorialVisible: false,
            isRegresar: true,
            isCabecera: true,
            ListCabecera: true,
            ListDetalle: false,
            isDisabled: false,
            isPagar: false,
            ltsPlanilla: false,
            isCancelado: false,
            _texto: '',
            listaTipoComprobante: [],
            clientes: [],
            listaEstadoPago: [],
            listaMetodoPago: [],
            listaCuentaDestino: [],
            listaBanco: [],
            listaCredito: [],
            listaMoneda: [],
            listaEstablecimientos: [],
            listaCaja: [],
            configuraciones: [],
            listaFormaPago: [],
            company: {},
            imprimirFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                formatos: printFormatMock.values,
                serieCorrelativo: ''
            },


            viewFormValues: {},
            estados: estadoMock.values,
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idEstablecimiento: 0,
                idCaja: 0,
                caja: '',
                idResponsable: 0,
                IdEstado: 0,
                nroPlanilla: '',
                idApertura: 0,
                idCliente: 0,
                serie: '',
                documento: '',
                tipoReporte: 1,
                idTipoComprobante: 0,
                cliente: '',
                estado: '',
                idFormaPago: 0,
                ...FILTER
            },
            IdApertura: 0,
            IdCaja: 0,
            pagination: PAGINATION,
            paginationDetalle: PAGINATION,
            paginationPlanilla: PAGINATION,
            paginationPlanilla_Detallado: PAGINATION,
            selectedItem: undefined,
            visible: false,
            formValues: this.fetchEmptyFormValues()
        }
    }

    // PAGINATION //

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            activeKey: "3",
            nombre: "",
            identifier: '',
            IdApertura: 0,
            IdCaja: 0,
            idCuentasCobrar: 0,
            idCuentasCobrarDetalle: 0,
            DocumentoCliente: '',
            RazonSocialClientemento: '',
            Moneda: '',
            Total: 0,
            flagPago: false,
            flagCredito: false,
            Saldo: 0,
            Monto: 0,
            nroCouta: 0,
            nro_documento: '',
            tipoCambio: 0,
            Fecha: global.fetchCurrentDateStr(),
            listaFormaPago: [],
            listaFormaPagoCredito: [],
            listaFormaPagoOtros: [],
            listaMetodoPago: [],
            listaCuentaDestino: [],
            listaComprobanteMasivo: [],
            listaBanco: [],
            listaCredito: [],
            listaMoneda: [],
            listaEstablecimientos: [],
            listaCaja: [],
            listaDetalleCredito: [],
            searchCreditoFormValues: {
                nombre: "",
                dataSource: [],
            },
            selectedRowKeys: [],
        }
    };

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idEstablecimiento: 0,
            idCaja: 0,
            caja: '',
            idResponsable: this.state.filter.idResponsable,
            IdEstado: 0,
            idApertura: this.state.ListCabecera ? 0 : this.state.filter.idApertura,
            nroPlanilla: this.state.ListCabecera ? '' : this.state.filter.nroPlanilla,
            idCliente: 0,
            serie: '',
            documento: '',
            tipoReporte: 1,
            idTipoComprobante: 0,
            cliente: '',
            estado: '',
            idFormaPago: 0,
            ...FILTER
        };

        this.setState({ filter });
        //this._handlePagination(filter);

    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = async (property, value, texto, param) => {
        const filter = { ...this.state.filter, [property]: value };
        if (texto != null) {
            var value = texto.label;
            filter[param] = value;
        }
        this.setState({ filter: filter });

        if (property === "tipoReporte" && this.state.ListDetalle == false) {

            var response = undefined;
            if (value == 1) {
                var response = await cobranzaService.verPlanillaResumen({ ...this.state.filter });

                this.setState({
                    paginationPlanilla: response
                })
            } else {

                var response = await cobranzaService.verPlanillaDetallado({ ...this.state.filter });
                this.setState({
                    paginationPlanilla_Detallado: response
                })
            }

        }

    };



    handleExportExcel = async () => {
        var name_file = 'Cobranza a cliente ' + this.state.filter.nroPlanilla + ".xlsx";
        this.setState({ loadingExcel: true });
        var response = undefined;
        debugger
        if (this.state.ListDetalle) {
            response = await cobranzaService.excelPlanilla(this.state.filter);
        }

        if (this.state.ListDetalle == false) {
            if (this.state.filter.tipoReporte == 1) {
                name_file = 'Planilla_Resumen.xlsx';
                response = await cobranzaService.excelPlanillaResumen(this.state.filter);
            } else {
                response = await cobranzaService.excelPlanillaDetallado(this.state.filter);
                name_file = 'Planilla_Detallado.xlsx';
            }
        }
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, name_file);
    }



    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await cuentasCobrarService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Cuentas por Cobrar.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await cuentasCobrarService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }


    handleExcel = async () => {
        var name_file = "Planilla de Cobranza.xlsx";
        this.setState({ loadingExcel: true });
        var response = await cobranzaService.excel(this.state.filter);

        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, name_file);
    }

    handlePdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await cobranzaService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Planilla de Cobranza.pdf");
    }
    // FORM MODAL //

    obtenerDatosIniciales = async () => {
        const datosInicialesFilter = {
            idUsuario: auth.user().id,
            idTipoComprobante: FACTURA.ID
        }
        const datosIniciales = await comprobanteService.datosIniciales(datosInicialesFilter);

        return datosIniciales;
    }

    onPagar = () => {
        this.setState({
            loadingVer: false,
            viewVisible: false,
            viewPagoVisible: true,
            isPagar: false,
        });
    };



    onReturn = () => {
        this.handleClearFilters();

        this.setState({
            pagination: PAGINATION
        });

        setTimeout(() => {
            var filter = { ...this.state.filter };
            filter.nroPlanilla = '';
            filter.idApertura = 0;

            this._initPagination(filter, cobranzaService.cobranza_clientes);

            this.handleCabecera();
        }, 100);

    };


    handleCabecera = () => {


        this.setState({
            isCabecera: true,
            ListCabecera: true,
            ListDetalle: false,
            isDisabled: false,
            isRegresar: true,

        });

    }

    handleSave = (values, form) => {
        debugger
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            response = await cuentasCobrarService.registrar(values);


            if (response.status === 200) {
                form.resetFields();
                this.setState({ viewPagoVisible: false, paginationDetalle: [] });
                message.success('Registrado' + ' correctamente.');
                //this._handlePagination(this.state.filter);
                this.handleDetalle();
                // this._initPagination({ ...this.state.filter}, cobranzaService.paginacion);

                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    //#region MODAL VIEW 
    handleDeletePago = async (item) => {
        this.handleClearFilters();

        var valuesStart = global.fetchCurrentDateStr().split("/");
        var valuesEnd = item.fechaReferencial.split("/");

        // Verificamos que la fecha no sea posterior a la actual
        var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
        var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);

        if (dateStart > dateEnd) {
            this.setState({ loadingPago: false })
            dialog.error('No puede realizar ningun abono ... revise la fecha de cierre referencial');
            return false

        }

        var filter = {
            ...this.state.filter,
            nroPlanilla: item.nroPlanilla,
            idApertura: item.id
        }

        this.setState({
            IdApertura: item.id,
            IdCaja: item.idCaja,
            filter: {
                ...this.state.filter,
                nroPlanilla: item.nroPlanilla,
                idApertura: item.id
            },
            isDisabled: true,
            ListCabecera: true,
            isCancelado: true,
            _texto: 'Anular Pago'
        });
        var response = await cobranzaService.documentos_cancelados(filter);

        if (response != null || response != undefined) {
            this.setState({
                paginationDetalle: response,
                ltsPlanilla: false
            })

            this.setState({
                isCabecera: false,
                ListCabecera: false,
                ListDetalle: true,
                isRegresar: false,
            });
        }



    }

    handleHistorial = (item) => {
        this.setState({ loadingPago: true })

        this.handleClearFilters();
        var valuesStart = global.fetchCurrentDateStr().split("/");
        var valuesEnd = item.fechaReferencial.split("/");

        // Verificamos que la fecha no sea posterior a la actual
        var dateStart = new Date(valuesStart[2], (valuesStart[1] - 1), valuesStart[0]);
        var dateEnd = new Date(valuesEnd[2], (valuesEnd[1] - 1), valuesEnd[0]);

        if (dateStart > dateEnd) {
            this.setState({ loadingPago: false })
            dialog.error('No puede realizar ningun abono ... revise la fecha de cierre referencial');
            return false

        } else {
            setTimeout(() => {

                this.setState({
                    IdApertura: item.id,
                    IdCaja: item.idCaja,
                    filter: {
                        ...this.state.filter,
                        nroPlanilla: item.nroPlanilla,
                        idApertura: item.id
                    },
                    isDisabled: true,
                    ListCabecera: true,
                    isCancelado: false,
                    _texto: 'Cobranza a Cliente'
                });

                this.handleDetalle()
            }, 100);
        }
        this.setState({ loadingPago: false })


    }
    handleDetalle = async () => {

        var response = await cobranzaService.paginacion({ ...this.state.filter });
        if (response != null || response != undefined) {
            this.setState({
                paginationDetalle: response,
                ltsPlanilla: false
            })

            this.setState({
                isCabecera: false,
                ListCabecera: false,
                ListDetalle: true,
                isRegresar: false,
            });
        }

    }


    handleChangeSelectedRowKey = (selected, rows) => {
        var isValido = true;

        var lista_todo = this.state.pagination.data;

        var lista_all = [];

        if (rows.length >= 2) {

            var IdDocumento = rows[0].id

            var dataExist = rows.filter(m => { return m.id == IdDocumento; });

            if (dataExist.length !== rows.length) {
                dialog.error("El documento seleccionado debe ser el mismo serie correlativo")

                this.setState({

                    isPagar: false,

                });

                return false;
            }

        }


        if (rows.length > 0)
            var totalCuotas = parseFloat(
                rows.reduce((a, b) => a + (b["montoCuota"] || 0), 0)
            );

        var metodo_pago = this.state.listaMetodoPago;
        var cuenta_destino = this.state.listaCuentaDestino;


        var listaComprobanteMasivo = new Array();
        var listaFormaPago = new Array();

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteMasivo: listaComprobanteMasivo
            },
        });



        if (rows.length > 0) {

            var fila = rows[0].id;

            rows.forEach(item => {

                listaComprobanteMasivo.push({
                    idCuentasCobrar: item.id,
                    idCuentasCobrarDetalle: item.idCuentasCobrarDetalle,
                    IdApertura: this.state.IdApertura,
                    fecha: '',
                    idMetodoPago: 0,
                    idCuenta: 0,
                    referencia: 0,
                    total: 0,
                })

                listaFormaPago.push({
                    identifier: global.fetchUniqueCode(),
                    idCuentasCobrar: item.id,
                    idCuentasCobrarDetalle: item.idCuentasCobrarDetalle,
                    fecha: global.fetchCurrentDateStr(),
                    idMetodoPago: 0,
                    idDestino: 0,
                    nroCouta: item.couta,
                    referencia: '',
                    montoCuota: item.montoCuota
                });

            });

            if (selected.length >= 2) {
                selected = selected.sort();


                lista_all = lista_todo.filter(m => m.id === fila);


                lista_all.forEach(function (data, index) {
                    var idSelected = selected[index];
                    if (idSelected === undefined || isValido == false) {
                        return false;
                    } else {
                        if (data.idCuentasCobrarDetalle == idSelected) {
                            //console.log("CUOTA valido" + idSelected)
                        } else {
                            isValido = false;
                            dialog.error('No se puede realizar el cobro ... Tiene que seleccionar cuotas en forma ordenada');
                            return false;
                        }
                    }

                });
            }

            this.setState({

                formValues: {
                    DocumentoCliente: rows[0].numeroDocumentoCliente,
                    RazonSocialClientemento: rows[0].razonSocialCliente,
                    Moneda: rows[0].moneda,
                    Monto: totalCuotas,
                    nroCouta: rows[0].couta.replace('CUOTA', ''),
                    Fecha: global.fetchCurrentDateStr(),
                    listaFormaPago: listaFormaPago,
                    listaMetodoPago: metodo_pago,
                    listaCuentaDestino: cuenta_destino,
                    listaComprobanteMasivo: listaComprobanteMasivo
                }


            });

        }

        if (isValido) {
            this.setState({
                viewPagoDetalle: rows.length == 0 ? false : true,
                isPagar: rows.length <= 1 ? false : true,
            });
        } else {
            this.setState({
                isPagar: false,
            });
        }

    };


    handleViewPago = async (item) => {
        console.log(item)
        this.setState({ loadingPago: true })
        var filter = new Object();
        filter.idCuentasCobrar = item.id;
        filter.idApertura = this.state.IdApertura;
        var _moneda = item.moneda.charAt(0);

        var response = await cobranzaService.cobranza_credito(filter);

        if (response.length > 1) {

            this.setState({
                loadingVer: false,
                viewVisible: false,
                viewPagoCreditoVisible: true,
                formValues: {
                    ...this.state.formValues,
                    DocumentoCliente: item.numeroDocumentoCliente,
                    RazonSocialClientemento: item.razonSocialCliente,
                    idCuentasCobrar: item.id,
                    activeKey: "3",
                    idCuentasCobrarDetalle: item.idCuentasCobrarDetalle,
                    IdApertura: this.state.IdApertura,
                    IdCaja: this.state.IdCaja,
                    Moneda: item.moneda,
                    Monto: _moneda == "S" ? (item.saldoSoles / item.tipoCambio) : (item.saldoSoles * item.tipoCambio),
                    nroCouta: item.couta,
                    Fecha: item.fechaStr,
                    tipoCambio: item.tipoCambio,
                    Total: _moneda == "S" ? item.totalSoles : item.totalSoles,
                    Saldo: _moneda == "S" ? item.saldoSoles : item.saldoSoles,
                    formaPago: item.formaPago,
                    flagPago: false,
                    flagCredito: item.idFormaPago == 2 ? true : false,
                    listaFormaPago: [],
                    flagDetraccion: item.flagDetraccion,
                    listaComprobanteMasivo: [],
                    listaFormaPagoCredito: [],
                    listaFormaPagoOtros: [],
                    tipoComprobante: item.tipoComprobante,
                    listaBanco: this.state.listaBanco,
                    listaMoneda: this.state.listaMoneda,
                    nro_documento: item.serieDocumentoComprobante,
                    listaDetalleCredito: response,
                }
            });

            return false;
        } else {


            this.setState({
                loadingVer: false,
                viewVisible: false,
                viewPagoVisible: true,
                formValues: {
                    ...this.state.formValues,
                    DocumentoCliente: item.numeroDocumentoCliente,
                    RazonSocialClientemento: item.razonSocialCliente,
                    idCuentasCobrar: item.id,
                    activeKey: "3",
                    idCuentasCobrarDetalle: response[0].idCuentasCobrarDetalle,
                    IdApertura: this.state.IdApertura,
                    IdCaja: this.state.IdCaja,
                    Moneda: item.moneda,
                    Monto: _moneda == "S" ? (item.saldoSoles / item.tipoCambio) : (item.saldoSoles * item.tipoCambio),
                    nroCouta: response[0].couta,
                    Fecha: item.fechaStr,
                    tipoCambio: item.tipoCambio,
                    Total: _moneda == "S" ? item.totalSoles : item.totalSoles,
                    Saldo: _moneda == "S" ? item.saldoSoles : item.saldoSoles,
                    flagPago: false,
                    flagCredito: response[0].idFormaPago == 2 ? true : false,
                    formaPago: item.formaPago,

                    listaFormaPago: [],
                    listaMetodoPago: this.state.listaMetodoPago,
                    listaCuentaDestino: this.state.listaCuentaDestino,
                    listaComprobanteMasivo: [],
                    listaFormaPagoCredito: [],
                    listaFormaPagoOtros: [],
                    tipoComprobante: item.tipoComprobante,
                    listaBanco: this.state.listaBanco,
                    listaMoneda: this.state.listaMoneda,
                    nro_documento: item.serieDocumentoComprobante,
                    flagDetraccion: response[0].flagDetraccion

                }
            });


        }
        this.setState({ loadingPago: false })

    }

    handleRemoverFormaPago = (item) => {
        var lista_FormaPago = this.state.formValues.listaFormaPago.filter(m => m.identifier !== item.identifier);
        var listaFormaPagoCredito = this.state.formValues.listaFormaPagoCredito.filter(m => m.identifier !== item.identifier);
        var listaFormaPagoOtros = this.state.formValues.listaFormaPagoOtros.filter(m => m.identifier !== item.identifier);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaFormaPago: lista_FormaPago,
                listaFormaPagoOtros: listaFormaPagoOtros,
                listaFormaPagoCredito: listaFormaPagoCredito
            }
        });


    };


    handleAddFormaPago = () => {
        var listaFormaPago = this.state.formValues.listaFormaPago;
        var listaFormaPagoCredito = this.state.formValues.listaFormaPagoCredito;
        var listaFormaPagoOtros = this.state.formValues.listaFormaPagoOtros;

        if (this.state.formValues.activeKey == "1") { //pago efectivo
            var moneda = this.state.formValues.Moneda == "SOLES" ? 1 : 2;

            if (listaFormaPago.length == 0) {

                listaFormaPago.push({
                    identifier: global.fetchUniqueCode(),
                    fecha: global.fetchCurrentDateStr(),
                    idMetodoPago: this.state.formValues.activeKey == "1" ? 4 : 0,
                    idDestino: 0,
                    nroDocumento: '',
                    idBanco: 0,
                    idMoneda: listaFormaPago.length == 0 ? moneda : (moneda == 1 ? 2 : 1),  //SOLES?DOLARES
                    referencia: '',
                    montoCuota: this.state.formValues.Saldo,
                    montoRecibido: 0,
                    montoVuelto: 0
                });
            } else {

                if (listaFormaPago.length <= 1) {
                    listaFormaPago.push({
                        identifier: global.fetchUniqueCode(),
                        fecha: global.fetchCurrentDateStr(),
                        idMetodoPago: this.state.formValues.activeKey == "1" ? 4 : 0,
                        idDestino: 0,
                        nroDocumento: '',
                        idBanco: 0,
                        idMoneda: listaFormaPago[0].idMoneda == 1 ? 2 : 1,  //SOLES?DOLARES
                        referencia: '',
                        montoCuota: this.state.formValues.Saldo,
                        montoRecibido: 0,
                        montoVuelto: 0
                    });
                }
            }


        }
        if (this.state.formValues.activeKey == "2") { //Pago credito

            if (this.state.formValues.nroCouta == "DETRACCIÓN") {
                dialog.error('No se puede cancelar con Nota de Credito aun DETRACCIÓN');
                return false;
            } else {
                listaFormaPagoCredito.push({
                    identifier: global.fetchUniqueCode(),
                    fecha: global.fetchCurrentDateStr(),
                    idMetodoPago: this.state.formValues.activeKey == "1" ? 8 : 0,
                    idDestino: 0,
                    nroDocumento: '',
                    idBanco: 0,
                    idMoneda: 0,
                    referencia: '',
                    montoCuota: 0,
                    montoRecibido: 0,
                    montoVuelto: 0
                });

            }

        }
        if (this.state.formValues.activeKey == "3") { //pago otros
            listaFormaPagoOtros.push({
                identifier: global.fetchUniqueCode(),
                fecha: global.fetchCurrentDateStr(),
                idMetodoPago: 0,
                idDestino: 0,
                nroDocumento: '',
                idBanco: 0,
                idMoneda: 0,
                referencia: '',
                montoCuota: 0,
                montoRecibido: 0,
                montoVuelto: 0
            });

        }


        this.setState({
            formValues: {
                ...this.state.formValues,
                listaFormaPago: listaFormaPago,
                listaFormaPagoOtros: listaFormaPagoOtros,
                listaFormaPagoCredito: listaFormaPagoCredito
            }
        });


    };


    handleSearch = async () => {

        var response = undefined;

        if (this.state.isCabecera) {
            response = await cobranzaService.cobranza_clientes({ ...this.state.filter });
            this.setState({
                pagination: response,
                ltsPlanilla: false
            })

            this.setState({
                isCabecera: true,
                ListCabecera: true,
                ListDetalle: false,
                isRegresar: true,
            });
            return false;
        }

        if (this.state.ListDetalle) {
            this.setState({
                paginationDetalle: [],
            })

            response = this.state.isCancelado ? await cobranzaService.documentos_cancelados({ ...this.state.filter }) :
                await cobranzaService.paginacion({ ...this.state.filter });

            this.setState({
                isCabecera: false,
                ListCabecera: false,
                ListDetalle: true,
                isRegresar: false,
                paginationDetalle: response ? response : [],
                ltsPlanilla: false
            });
            return false;
        }

        if (this.state.isCabecera === false && this.state.ListDetalle == false) {

            if (this.state.filter.tipoReporte == 1) {
                var filter = { ...this.state.filter };
                filter.page = 1;
                response = await cobranzaService.verPlanillaResumen(filter);
                if (response != undefined) {
                    response.pageSize = response.data.length == 0 ? 0 : response.pageSize
                    response.total = response.data.length == 0 ? 0 : response.total

                }
                this.setState({
                    paginationPlanilla: response,
                })
            } else {

                this.setState({
                    paginationPlanilla_Detallado: [],
                })
                var filter = { ...this.state.filter };
                filter.page = 1;
                response = await cobranzaService.verPlanillaDetallado(filter);
                if (response != undefined) {
                    response.pageSize = response.data.length == 0 ? 0 : response.pageSize
                    response.total = response.data.length == 0 ? 0 : response.total

                }
                this.setState({
                    paginationPlanilla_Detallado: response,
                })
            }
        }
    }

    ChangePagination = async (pagination) => {
        debugger
        const filter = { ...this.state.filter, ...pagination };
        this.setState({ filter: filter, paginationDetalle: [], pagination: [], paginationPlanilla_Detallado: [] });

        setTimeout(() => {
            this.ChangePaginationGetData();
        }, 100);

    }

    ChangePaginationGetData = async () => {
        var response = undefined;

        if (this.state.isCabecera) {
            response = await cobranzaService.cobranza_clientes({ ...this.state.filter });
            this.setState({
                pagination: response,
                ltsPlanilla: false
            })

            this.setState({
                isCabecera: true,
                ListCabecera: true,
                ListDetalle: false,
                isRegresar: true,
            });
            return false;
        }

        if (this.state.ListDetalle) {
            response = this.state.isCancelado ? await cobranzaService.documentos_cancelados({ ...this.state.filter }) : await cobranzaService.paginacion({ ...this.state.filter });
            this.setState({
                paginationDetalle: response,
                ltsPlanilla: false
            })

            this.setState({
                isCabecera: false,
                ListCabecera: false,
                ListDetalle: true,
                isRegresar: false,
            });
            return false;
        }

        if (this.state.isCabecera === false && this.state.ListDetalle == false) {

            if (this.state.filter.tipoReporte == 1) {
                if (response != undefined) {
                    response.pageSize = response.data.length == 0 ? 0 : response.pageSize
                    response.total = response.data.length == 0 ? 0 : response.total

                }
                response = await cobranzaService.verPlanillaResumen({ ...this.state.filter });

                this.setState({
                    paginationPlanilla: response,
                })
            } else {
                response = await cobranzaService.verPlanillaDetallado({ ...this.state.filter });
                if (response != undefined) {
                    response.pageSize = response.data.length == 0 ? 0 : response.pageSize
                    response.total = response.data.length == 0 ? 0 : response.total

                }
                this.setState({
                    paginationPlanilla_Detallado: response,
                })
            }
        }
    }

    //#endregion MODAL


    //#region Imprimir


    handleImprimir = async (item) => {

        this.setState({ loadingImprimir: true });
        var file = undefined;
        var response = undefined;
        var idFormato = this.state.company.formatoPrint;

        if (idFormato === 1) {
            response = await cobranzaService.pdfA4({
                idCuentasCobrar: item.idCuentasCobrarDetalle, idTipoDocumento: 1,
                nroPlanilla: this.state.filter.nroPlanilla,
                idCajaApertura: this.state.filter.idApertura
            });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cobranzaService.ticket({
                idCuentasCobrar: item.idCuentasCobrarDetalle, idTipoDocumento: 1,
                nroPlanilla: this.state.filter.nroPlanilla,
                idCajaApertura: this.state.filter.idApertura

            });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await cobranzaService.ticket50({
                idCuentasCobrar: item.idCuentasCobrarDetalle, idTipoDocumento: 1,
                nroPlanilla: this.state.filter.nroPlanilla,
                idCajaApertura: this.state.filter.idApertura

            });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            loadingImprimir: false,
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                idComprobante: item
            },
            selectedItem: item
        });
    };

    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {

            response = await cobranzaService.pdfA4({
                idCuentasCobrar: this.state.selectedItem.idCuentasCobrarDetalle, idTipoDocumento: 1,
                nroPlanilla: this.state.filter.nroPlanilla
            });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await cobranzaService.ticket({
                idCuentasCobrar: this.state.selectedItem.idCuentasCobrarDetalle, idTipoDocumento: 1,
                nroPlanilla: this.state.filter.nroPlanilla
            });

            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 3) {
            response = await cobranzaService.ticket50({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file
            }
        });
    };

    handleDownloadPdf = async () => {

        var response = undefined;
        var file = undefined;

        if (this.state.imprimirFormValues.idFormato === 1) {
            response = await cuentasCobrarService.pdfA4({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (this.state.imprimirFormValues.idFormato === 2) {
            response = await cuentasCobrarService.ticket({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (this.state.imprimirFormValues.idFormato === 3) {
            response = await cuentasCobrarService.ticket50({ id: this.state.imprimirFormValues.idComprobante });
            file = window.URL.createObjectURL(response.data);
        }

        if (response !== undefined)
            global.dowloadFile(response.data, this.state.viewFormValues.NumeroDocumento + ".pdf");
    };


    handleSelectProduct = (row) => {
        debugger
        var idNota = this.state.listaMetodoPago.filter(item => (item.nombre.toUpperCase()).charAt(0) == "N");

        var identifier = this.state.formValues.identifier;
        var listaFormaPagoCredito = this.state.formValues.listaFormaPagoCredito.filter(row => row.identifier != identifier);
        var date = this.state.formValues.listaFormaPagoCredito.filter(row => row.identifier == identifier);

        var listaCredito = listaFormaPagoCredito.filter(element => element.nroDocumento == row.nroDocumento);

        if (listaCredito.length > 0) {
            dialog.error('No se puede duplicar Nota de credito');

        } else {
            listaFormaPagoCredito.push({
                identifier: global.fetchUniqueCode(),
                fecha: date == undefined ? global.fetchCurrentDateStr() : date[0].fecha,
                idMetodoPago: idNota == undefined ? 6 : parseInt(idNota[0].id),
                idDestino: 0,
                nroDocumento: row.nroDocumento,
                idBanco: 0,
                idMoneda: row.moneda == "SOLES" ? 1 : 2,
                referencia: '',
                montoCuota: parseFloat(row.total),
                montoRecibido: 0,
                montoVuelto: 0
            });
            this.setState({
                formValues: {
                    ...this.state.formValues,

                    listaFormaPagoCredito: listaFormaPagoCredito
                }
            });
        }


    };

    onSwitch = (element) => {

        this.setState({
            formValues: {
                ...this.state.formValues,
                flagPago: element,
            },
        });

    }


    handleChangeTab = (key, onSetFieldsValue) => {

        if (key == "1") {
            // Referencias
            onSetFieldsValue({
                flagReferencia: true,
            });
        }
        if (key == "2") { // Metodo de Pago
            onSetFieldsValue({
                flagMetodoPago: true
            })
        }
        if (key == "3") { // Metodo de Pago
            onSetFieldsValue({
                flagMetodoPago: true
            })
        }


        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key,
            },
        });
    };



    handleChangePago = async (label, property, value, identifier, index) => {

        if (property == "idBanco") {
            var banco = this.state.listaBanco.filter(b => b.id == value);
            const cuentaDestino = await cuentaService.obtenerPorId(banco[0].idEntidad);

            this.setState({
                listaCuentaDestino: cuentaDestino ? cuentaDestino : [],
                formValues: {
                    ...this.state.formValues,
                    listaCuentaDestino: cuentaDestino ? cuentaDestino : [],
                    idDestino: 0
                }
            })

        }

        if (property == "fecha") {
            switch (this.state.formValues.activeKey) {
                case "1":
                    this.state.formValues.listaFormaPago.forEach(element => {
                        if (element.identifier == identifier) {
                            element.fecha = value;
                            return false;
                        }
                    });
                    break;
                case "2":
                    this.state.formValues.listaFormaPagoCredito.forEach(element => {
                        if (element.identifier == identifier) {
                            element.fecha = value;
                            return false;
                        }
                    });
                    break;
                case "3":
                    this.state.formValues.listaFormaPagoOtros.forEach(element => {
                        if (element.identifier == identifier) {
                            element.fecha = value;
                            return false;
                        }
                    });
                    break;
                default:
                    break;
            }

        }

        if (property == "idMetodoPago") {
            var isNota = label.split(" ")[0].toUpperCase();

            if (isNota == "NOTA") {

                var cliente = this.state.clientes.filter(e => e.numeroDocumento == this.state.formValues.DocumentoCliente);
                if (["01", "03"].includes(this.state.formValues.tipoComprobante)) {

                    var NotaCredito = await cobranzaService.obtenerDocumentoNroSerie(cliente[0].id);
                    NotaCredito = NotaCredito.filter(e => e.tipoComprobante == this.state.formValues.tipoComprobante);

                    this.setState({
                        viewCredito: true,
                        listaCredito: NotaCredito ? NotaCredito : [],
                        formValues: {
                            ...this.state.formValues,
                            listaCredito: NotaCredito ? NotaCredito : [],
                            identifier: identifier
                        }
                    })
                } else {
                    dialog.error('La nota de crédito solo aplica para Factura o Boleta');
                    return false;
                }

            } else {

                if (this.state.formValues.activeKey == "1") {
                    this.state.formValues.listaFormaPago.forEach(element => {
                        if (element.identifier == identifier) {
                            element.idMetodoPago = value
                        }
                    });
                }
                if (this.state.formValues.activeKey == "3") {
                    this.state.formValues.listaFormaPagoOtros.forEach(element => {
                        if (element.identifier == identifier) {
                            element.idMetodoPago = value
                        }
                    });
                }

            }


        }

        if (property == "idMonto") {
            var moneda = this.state.formValues.Moneda == "SOLES" ? 1 : 2;
            var tipoCambio = this.state.formValues.tipoCambio;
            var valorNuevo = [];
            var montoNuevo = 0;
            var formaPago = this.state.formValues.activeKey == "1" ? this.state.formValues.listaFormaPago.filter(e => e.identifier == identifier) :
                this.state.formValues.listaFormaPagoOtros.filter(e => e.identifier == identifier);

            if (this.state.formValues.listaFormaPago.length == 2) {

                if (moneda == 2) { //cuando el documento es dolares
                    if (formaPago[0].idMoneda == moneda) {

                        montoNuevo = ((this.state.formValues.Saldo - value) * tipoCambio).toFixed(2);

                    } else {
                        montoNuevo = (value / tipoCambio).toFixed(2)
                        montoNuevo = (this.state.formValues.Saldo - montoNuevo).toFixed(2);
                    }

                } else {

                    if (formaPago[0].idMoneda == moneda) {
                        montoNuevo = (this.state.formValues.Saldo - value).toFixed(2);
                        montoNuevo = (montoNuevo / tipoCambio).toFixed(2)

                    } else {

                        montoNuevo = (this.state.formValues.Saldo - (value * tipoCambio)).toFixed(2);

                    }

                }

                this.state.formValues.listaFormaPago.forEach((key, index) => {

                    if (key.identifier == identifier) {

                        var dataNueva = {
                            identifier: global.fetchUniqueCode(),
                            fecha: key.fecha,
                            idMetodoPago: 4,
                            idDestino: 0,
                            nroDocumento: '',
                            idBanco: 0,
                            idMoneda: formaPago[0].idMoneda == 1 ? 1 : 2,  //SOLES ? DOLARES
                            referencia: formaPago[0].referencia,
                            montoCuota: parseFloat(value),
                            montoRecibido: 0,
                            montoVuelto: 0
                        };

                        valorNuevo.splice(index, 0, dataNueva);

                    } else {
                        var dataNueva = {
                            identifier: global.fetchUniqueCode(),
                            fecha: key.fecha,
                            idMetodoPago: 4,
                            idDestino: 0,
                            nroDocumento: '',
                            idBanco: 0,
                            idMoneda: formaPago[0].idMoneda == 1 ? 2 : 1,  //SOLES ? DOLARES
                            referencia: formaPago[0].referencia,
                            montoCuota: parseFloat(montoNuevo),
                            montoRecibido: 0,
                            montoVuelto: 0
                        };

                        valorNuevo.splice(index, 0, dataNueva);
                    }



                });

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaFormaPago: valorNuevo,
                    }
                });

            } else {


                if (this.state.formValues.activeKey == "1") {
                    var dataNueva = {
                        identifier: global.fetchUniqueCode(),
                        fecha: formaPago[0].fecha,
                        idMetodoPago: 4,
                        idDestino: 0,
                        nroDocumento: '',
                        idBanco: 0,
                        idMoneda: formaPago[0].idMoneda == 1 ? 1 : 2,  //SOLES ? DOLARES
                        referencia: formaPago[0].referencia,
                        montoCuota: parseFloat(value),
                        montoRecibido: 0,
                        montoVuelto: 0
                    };

                    valorNuevo.splice(index, 0, dataNueva);

                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            listaFormaPago: valorNuevo,
                        }
                    });
                } else {

                    var valorNuevo = this.state.formValues.listaFormaPagoOtros.filter(e => e.identifier != identifier);

                    var dataNueva = {
                        identifier: global.fetchUniqueCode(),
                        fecha: formaPago[0].fecha,
                        idMetodoPago: formaPago[0].idMetodoPago,
                        idDestino: formaPago[0].idDestino,
                        nroDocumento: formaPago[0].nroDocumento,
                        idBanco: formaPago[0].idBanco,
                        idMoneda: formaPago[0].idMoneda == 1 ? 1 : 2,  //SOLES ? DOLARES
                        referencia: formaPago[0].referencia,
                        montoCuota: parseFloat(value),
                        montoRecibido: formaPago[0].montoRecibido,
                        montoVuelto: formaPago[0].montoVuelto
                    };

                    valorNuevo.splice(index, 0, dataNueva);

                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            listaFormaPagoOtros: valorNuevo,
                        }
                    });
                }

            }

        }

        if (property == "idMoneda") {

            if (this.state.formValues.listaFormaPago.length == 1) {

                var moneda = this.state.formValues.Moneda == "SOLES" ? 1 : 2;

                var montoCuota = 0;
                if (moneda == value) {

                    montoCuota = this.state.formValues.Saldo;
                } else {
                    montoCuota = this.state.formValues.Monto;

                }

                var formaPago = [];
                formaPago.push({
                    identifier: global.fetchUniqueCode(),
                    fecha: this.state.formValues.listaFormaPago[0].fecha,
                    idMetodoPago: 4,
                    idDestino: 0,
                    nroDocumento: '',
                    idBanco: 0,
                    idMoneda: value,  //SOLES ? DOLARES
                    referencia: '',
                    montoCuota: parseFloat(montoCuota),
                    montoRecibido: 0,
                    montoVuelto: 0
                });


                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaFormaPago: formaPago,
                    }
                });

            } else {

                var formaPago = this.state.formValues.listaFormaPago.filter(e => e.identifier != identifier);
                var dataNueva = {
                    identifier: global.fetchUniqueCode(),
                    fecha: global.fetchCurrentDateStr(),
                    idMetodoPago: 4,
                    idDestino: 0,
                    nroDocumento: '',
                    idBanco: 0,
                    idMoneda: this.state.formValues.listaFormaPago[0] == 1 ? 2 : 1,  //SOLES ? DOLARES
                    referencia: '',
                    montoCuota: 0,
                    montoRecibido: 0,
                    montoVuelto: 0
                };

                formaPago.splice(index, 0, dataNueva);

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaFormaPago: formaPago
                    }
                });

            }
        }

        if (property == "idRecibido") {

            var moneda = this.state.formValues.Moneda == "SOLES" ? 1 : 2;

            var formaPago = this.state.formValues.listaFormaPago.filter(e => e.identifier == identifier);
            var ListaPago = [];


            if (formaPago[0].montoCuota == 0) {

                dialog.error('Ingrese el monto a cobrar');
                return false;
            }
            if (parseFloat(formaPago[0].montoCuota.toFixed(2)) > parseFloat(value)) {

                dialog.error('Monto recibido debe ser mayor o igual al monto cobrar');
                return false;
            }

            this.state.formValues.listaFormaPago.forEach((key, index) => {

                if (key.identifier == identifier) {

                    ListaPago.push({
                        identifier: key.identifier,
                        fecha: key.fecha,
                        idMetodoPago: key.idMetodoPago,
                        idDestino: key.idDestino,
                        nroDocumento: key.nroDocumento,
                        idBanco: key.idBanco,
                        idMoneda: key.idMoneda,
                        referencia: key.referencia,
                        montoCuota: key.montoCuota,
                        montoRecibido: parseFloat(value),
                        montoVuelto: (value - (key.montoCuota.toFixed(2)))
                    });
                } else {

                    ListaPago.push({
                        identifier: key.identifier,
                        fecha: key.fecha,
                        idMetodoPago: key.idMetodoPago,
                        idDestino: key.idDestino,
                        nroDocumento: key.nroDocumento,
                        idBanco: key.idBanco,
                        idMoneda: key.idMoneda,
                        referencia: key.referencia,
                        montoCuota: key.montoCuota,
                        montoRecibido: key.montoRecibido,
                        montoVuelto: key.montoVuelto
                    });
                }
            });



            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listaFormaPago: ListaPago,
                }
            });


        }

        if (property == "idReferencia") {
            this.state.formValues.listaFormaPagoOtros.forEach(element => {
                if (element.identifier == identifier) {
                    element.referencia = value;
                }
            });

        }


    };

    onOtrosPago = (element, form) => {


        this.setState({
            formValues: {
                ...this.state.formValues,
                listaFormaPagoOtros: element,
            }
        });

    }
    //#endregion Imprimir

    handleSelectCredito = (row, item) => {
        if (row.length == 1) {

            var id = item[0].idCuentasCobrarDetalle;
            const posicion = item[0].flagDetraccion ? 0 : this.state.formValues.listaDetalleCredito.findIndex(elemento => elemento.idCuentasCobrarDetalle === id);

            if (posicion != 0) {
                dialog.error('No se puede realizar el cobro ... Tiene que seleccionar cuotas en forma ordenada');
                return false;
            }

            var moneda = item[0].moneda;
            moneda = moneda.charAt(0);

            this.setState({
                loadingVer: false,
                viewVisible: false,
                formValues: {
                    ...this.state.formValues,
                    idCuentasCobrar: item[0].id,
                    activeKey: "3",
                    idCuentasCobrarDetalle: item[0].idCuentasCobrarDetalle,
                    Moneda: item[0].moneda,
                    Monto: moneda == "D" ? (item[0].montoCuota * item[0].tipoCambio) : (item[0].montoCuota / item[0].tipoCambio),
                    nroCouta: item[0].couta.replace('CUOTA', ''),
                    Fecha: item[0].fechaStr,
                    tipoCambio: item[0].tipoCambio,
                    Saldo: item[0].montoCuota,
                    flagPago: false,
                    formaPago: item[0].formaPago,
                    flagCredito: item[0].idFormaPago == 2 ? true : false,
                    flagDetraccion: item[0].flagDetraccion,
                    listaComprobanteMasivo: [],
                    listaMetodoPago: this.state.listaMetodoPago,
                    listaCuentaDestino: this.state.listaCuentaDestino,
                    listaFormaPagoCredito: [],
                    listaBanco: this.state.listaBanco,
                    listaMoneda: this.state.listaMoneda,
                    selectedRowKeys: row
                }
            });
            return true;
        }

        if (row.length == 0) {
            this.setState({
                loadingVer: false,
                viewVisible: false,
                formValues: {
                    ...this.state.formValues,
                    selectedRowKeys: [],
                }
            });
            return true;
        }

        else {
            dialog.error('Solo se puede seleccionar una cuota');
            return false
        }
    };


    handleNextPago = async (item, form) => {
        if (this.state.formValues.selectedRowKeys.length == 0) {
            dialog.warning("Seleccione cuota a pagar");
            return false;
        }
        this.setState({
            loadingVer: false,
            viewVisible: false,
            loadingPago: false,
            viewPagoVisible: true,
            viewPagoCreditoVisible: false,
            formValues: {
                ...this.state.formValues,
                selectedRowKeys: [],
            }
        });

    }

    handleClosePago = async () => {
        this.setState({
            loadingVer: false,
            viewVisible: false,
            loadingPago: false,
            viewPagoCreditoVisible: false,
            formValues: {
                ...this.state.formValues,
                selectedRowKeys: [],
                flagDetraccion: false,
            }
        });

    }
    //#region  ver Planilla 

    handleVerPlanilla = async (row) => {
        this.setState({
            isCabecera: false,
            ListCabecera: false,
            ListDetalle: false,
            isRegresar: false,
            ltsPlanilla: true,
            _texto: 'Ver Planilla ',
            filter: {
                ...this.state.filter,
                nroPlanilla: row.nroPlanilla,
                idApertura: row.id,
                page: 1
            },
        });

        setTimeout(() => { this.handlePlanilla() }, 200)
    }

    handlePlanilla = async () => {
        var response = await cobranzaService.verPlanillaResumen({ ...this.state.filter });
        if (response != undefined) {
            response.pageSize = response.data.length == 0 ? 0 : response.pageSize
            response.total = response.data.length == 0 ? 0 : response.total

        }
        this.setState({
            paginationPlanilla: response
        })
    }

    handleAnular = (values) => {
        var param = values;
        param.idCajaApertura = this.state.filter.idApertura;

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response = await cobranzaService.anular(param);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');

                var response = await cobranzaService.documentos_cancelados({ ...this.state.filter });
                this.setState({
                    isCabecera: false,
                    ListCabecera: false,
                    ListDetalle: true,
                    isRegresar: false,
                    paginationDetalle: response,
                    ltsPlanilla: false
                });

                return;
            }

            if (response.status === 400) {
                dialog.warning(
                    <ul>
                        {response.data.messages.map((item) => (
                            <li>{item}</li>
                        ))}
                    </ul>
                );
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    //#endregion

    async componentDidMount() {
        var idUsuario = auth.user().id;
        const empresa = await empresaService.obtenerPrincipal(0);

        const metodoPagos = await metodoPagoService.listar();
        const bancos = await bancoService.listarBancoCuentas();
        const monedas = await monedaService.listar();
        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: TESORERIA });

        var flagTS = configuraciones.filter((m) => m.abreviatura === VER_CAJA_COB).length >= 1 ? true : false;

        const idResponsable = flagTS ? 0 : auth.user().id;

        this._initPagination({ ...this.state.filter, idResponsable }, cobranzaService.cobranza_clientes);

        const establecimientos = await establecimientoService.principales();
        const caja = await cajaService.listar();

        const estadoPagar = await cuentasCobrarService.listar_estados();

        const clientes = await clienteService.listar();
        const formaPago = await formaPagoService.listar();

        this.setState({
            loadingSource: false,
            clientes: clientes ? clientes : [],
            listaMetodoPago: metodoPagos ? metodoPagos : [],
            listaCuentaDestino: [],
            listaEstadoPago: estadoPagar ? estadoPagar : [],
            listaBanco: bancos ? bancos : [],
            listaMoneda: monedas ? monedas : [],
            listaEstablecimientos: establecimientos ? establecimientos : [],
            listaCaja: caja ? caja : [],
            listaFormaPago: formaPago ? formaPago : [],
            configuraciones: configuraciones ? configuraciones : [],
            company: empresa,
            listaTipoComprobante: [{ 'id': 2, 'nombre': 'FACTURA' }, { 'id': 4, 'nombre': 'BOLETA' }, { 'id': 97, 'nombre': 'NOTA VENTA' }],
            filter: {
                ...this.state.filter,
                idResponsable: idResponsable
            }

        });
    }

    render() {
        return (
            <div>
                <Header
                    title={this.state.isCabecera ? "Planilla de Cobranza" : this.state._texto + " " + this.state.filter.nroPlanilla}
                    onReturn={this.onReturn}
                    onPagar={this.onPagar}
                    loadingNew={this.state.loadingSource}
                    isRegresar={this.state.isRegresar}
                    onSearch={this.handleSearch}
                    onClearFilters={this.handleClearFilters}
                    isPagar={this.state.isPagar}

                />
                <Filters
                    filter={this.state.filter}
                    clientes={this.state.clientes}
                    estado={this.state.listaEstadoPago}
                    establecimientos={this.state.listaEstablecimientos}
                    caja={this.state.listaCaja}
                    listaFormaPago={this.state.listaFormaPago}
                    comprobantes={this.state.listaTipoComprobante}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    isCabecera={this.state.isCabecera}
                    isDisabled={this.state.isDisabled}
                    isPlanilla={this.state.ltsPlanilla}

                />

                {(() => {

                    if (this.state.ListCabecera) {

                        return <ResultList
                            pagination={this.state.pagination}
                            loadingEdit={this.state.loadingSource}
                            loadingExcel={this.state.loadingExcel}
                            loadingPdf={this.state.loadingPdf}
                            loadingPrint={this.state.loadingPrint}
                            loadingPago={this.state.loadingPago}
                            onExportExcel={this.handleExcel}
                            onExportPdf={this.handlePdf}
                            onPrint={this.handlePrint}
                            onPago={this.handleHistorial}
                            onViewPlanilla={this.handleVerPlanilla}
                            onChange={this.ChangePagination}
                            onDelete={this.handleDeletePago}

                        />
                    }
                    if (this.state.ListDetalle) {
                        return <ResultListDetalle
                            visible={this.state.ListDetalle}
                            isCancelado={this.state.isCancelado}
                            pagination={this.state.paginationDetalle}
                            loadingExcel={this.state.loadingExcel}
                            loadingPdf={this.state.loadingPdf}
                            loadingPrint={this.state.loadingPrint}
                            loadingPago={this.state.loadingPago}
                            onExportExcel={this.handleExportExcel}
                            onExportPdf={this.handleExportPdf}
                            onChange={this.ChangePagination}
                            onViewPago={this.handleViewPago}
                            onAnular={this.handleAnular}
                            onChangeRow={this.handleChangeSelectedRowKey}
                        />
                    }

                    return (
                        <div>
                            {this.state.filter.tipoReporte == 1 ?

                                <ResultListPlanillaResumen
                                    visible={this.state.ListDetalle}
                                    pagination={this.state.paginationPlanilla}
                                    loadingImprimir={this.state.loadingImprimir}
                                    loadingExcel={this.state.loadingExcel}
                                    loadingPdf={this.state.loadingPdf}
                                    loadingPrint={this.state.loadingPrint}
                                    onExportExcel={this.handleExportExcel}
                                    onExportPdf={this.handleExportPdf}
                                    onPrint={this.handlePrint}
                                    onChange={this.ChangePagination}
                                    onImprimir={this.handleImprimir}
                                />
                                :
                                <ResultListPlanillaDetallado
                                    visible={this.state.ListDetalle}
                                    pagination={this.state.paginationPlanilla_Detallado}
                                    loadingExcel={this.state.loadingExcel}
                                    loadingPdf={this.state.loadingPdf}
                                    loadingPrint={this.state.loadingPrint}
                                    onExportExcel={this.handleExportExcel}
                                    onExportPdf={this.handleExportPdf}
                                    onPrint={this.handlePrint}
                                    onChange={this.ChangePagination}
                                />
                            }
                        </div>
                    )



                })()}

                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onDownload={this.handleDownloadPdf}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />


                <ViewPago
                    onRemoverFormaPago={this.handleRemoverFormaPago}
                    onAgregarDetalle={this.handleAddFormaPago}
                    onSave={this.handleSave}
                    visible={this.state.viewPagoVisible}
                    visibleDetalle={this.state.viewPagoDetalle}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ viewPagoVisible: false, loadingPago: false })}
                    onChangePago={this.handleChangePago}
                    onChangeTab={this.handleChangeTab}
                    onSwitch={this.onSwitch}
                    onOtrosPago={this.onOtrosPago}
                />

                <ViewPagoCredito
                    visible={this.state.viewPagoCreditoVisible}
                    formValues={this.state.formValues}
                    onChangeRow={this.handleSelectCredito}
                    onClose={this.handleClosePago}
                    onNext={this.handleNextPago}
                />


                <SearchCreditoModal
                    visible={this.state.viewCredito}
                    formValues={this.state.formValues}
                    onCancel={() => this.setState({ viewCredito: false })}
                    dataSource={this.state.formValues.listaCredito}
                    onSelect={this.handleSelectProduct}
                />


            </div>
        );
    };
}